<body>

    <div style="display: none" id="vehicleSessionView">
        <form>
            <table cellspacing="0" cellpadding="2">
                <tbody>
                    <tr>
                        <td class="printOption"><span onclick="window.close()"><img src="/assets/images/EtisClose.gif"
                                    alt="Close" title="Close" width="12" height="11" border="0"></span>&nbsp;
                            <span onclick="window.close()" title="Close" class="icon">{{'Close'|translate}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table class="sessionSummaryTable" cellspacing="0" cellpadding="3">
                                <tbody>
                                    <tr>
                                        <!-- <td class="documentHeader">{{'FordEtis IDS Vehicle Session Summary'|translate}} -->
                                        <td class="documentHeader">{{'Vehicle Session Summary'|translate}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="reportAProblem">
                                            <span onclick="window.print()"><img src="/assets/images/EtisPrint.gif"
                                                    alt="Print" title="Print" width="12" height="11"
                                                    border="0"></span>&nbsp;<span onclick="window.print()" title="Print"
                                                class="icon">{{'Print'|translate}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="doNotFloat" id="tabs">
                                                <table width="100%" cellspacing="0" cellpadding="0" border="0">
                                                    <tbody>
                                                        <tr class="tabContainerRow0">
                                                            <td>
                                                                <table class="tabRow0" cellspacing="0" cellpadding="2"
                                                                    border="0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td class="left" id="celldetailsleft"></td>
                                                                            <td class="link" id="celldetails">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('details')">{{'Details'|translate}}</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right" id="celldetailsright">
                                                                            </td>
                                                                            <td class="left" id="cellindictmentleft">
                                                                            </td>
                                                                            <td class="link" id="cellindictment">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('indictment')">{{'Indictment'|translate}}</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right" id="cellindictmentright">
                                                                            </td>
                                                                            <td class="left" id="celldiagnosticleft">
                                                                            </td>
                                                                            <td class="link" id="celldiagnostic">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('diagnostic')">{{'Diagnostic'|translate}}
                                                                                    </a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right" id="celldiagnosticright">
                                                                            </td>
                                                                            <td class="selectedLeft"
                                                                                id="cellrepairleft">
                                                                            </td>
                                                                            <td class="selectedLink" id="cellrepair">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('repair')">{{'Repair'|translate}}</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="selectedRight"
                                                                                id="cellrepairright">
                                                                            </td>
                                                                            <td class="left"
                                                                                id="cellmoduleSoftwareleft">
                                                                            </td>
                                                                            <td class="link" id="cellmoduleSoftware">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('moduleSoftware')">{{'Module
                                                                                        and Software'|translate}}</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right"
                                                                                id="cellmoduleSoftwareright">
                                                                            </td>
                                                                            <td class="left"
                                                                                id="cellsystemSnapshotleft">
                                                                            </td>
                                                                            <td class="link" id="cellsystemSnapshot">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('systemSnapshot')">{{'System
                                                                                        Snapshot'|translate}}</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right"
                                                                                id="cellsystemSnapshotright">
                                                                            </td>
                                                                            <td class="left"
                                                                                id="celldataCollectionleft">
                                                                            </td>
                                                                            <td class="link" id="celldataCollection">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('dataCollection')">{{'Data
                                                                                        Collection'|translate}}</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right"
                                                                                id="celldataCollectionright">
                                                                            </td>
                                                                            <td class="left" id="cellworkflowleft"></td>
                                                                            <td class="link" id="cellworkflow">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('workflow')">{{'Workflow'|translate}}</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right" id="cellworkflowright">
                                                                            </td>
                                                                            <td class="left" id="cellvehicleleft"></td>
                                                                            <td class="link" id="cellvehicle">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('vehicle')">{{'Vehicle
                                                                                        Model'|translate}}</a>


                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right" id="cellvehicleright">
                                                                            </td>
                                                                            <td *ngIf="otxDataAvailable" class="left"
                                                                                id="cellotxleft"></td>
                                                                            <td *ngIf="otxDataAvailable" class="link"
                                                                                id="cellotx">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('otx')">OTX</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td *ngIf="otxDataAvailable" class="right"
                                                                                id="cellotxright"></td>
                                                                            <!-- <td class="left" id="cellctleft"></td>
                                                                        <td class="link" id="cellct">
                                                                            <nobr><a class="heading"
                                                                                    (click)="showPart('ct')">Complex
                                                                                    Tools</a>
                                                                            </nobr>
                                                                        </td>
                                                                        <td class="right" id="cellctright"></td> -->
                                                                            <td class="left" id="celldisplayAllleft">
                                                                            </td>
                                                                            <td class="link" id="celldisplayAll">
                                                                                <nobr><a class="heading"
                                                                                        (click)="showPart('displayAll'); showAll()">{{'Display
                                                                                        All'|translate}}</a>
                                                                                </nobr>
                                                                            </td>
                                                                            <td class="right" id="celldisplayAllright">
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="background-color: #003f87; font-size: 2pt">&nbsp;
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div style="display: none;" id="detailsSection">
                                                <hr>
                                                <p class="head">{{'Details'|translate}}</p>
                                                <hr *ngIf='sessionAvailable'>
                                                <div class="sessionTitle" *ngIf='sessionAvailable'>{{'Customer
                                                    Details'|translate}}</div>
                                                <table *ngIf='sessionAvailable'>
                                                    <tbody>
                                                        <tr>
                                                            <th width="170" align="left">{{'Customer
                                                                Concerns'|translate}}:
                                                            </th>
                                                            <td>{{ customerConcern }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <br>
                                                <hr>
                                                <div class="sessionTitle">{{'Vehicle Details'|translate}}</div>
                                                <table *ngIf="sbdoService">
                                                    <tbody>
                                                        <tr>
                                                            <th width="170" align="left">{{'VIN'|translate}}:</th>
                                                            <td>{{ vinAvailable }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'model'|translate}}:</th>
                                                            <td id="vehicleDetailsModel"
                                                                *ngIf="vehicleDetailsAvailable && hardFeaturesData.DisplayName[0].Name">
                                                                {{
                                                                hardFeaturesData.DisplayName[0].Name[0] }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Year'|translate}}:</th>
                                                            <td
                                                                *ngIf="vehicleDetailsAvailable && hardFeaturesData.ModelYear">
                                                                {{
                                                                hardFeaturesData.ModelYear[0]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Build'|translate}}:</th>
                                                            <td
                                                                *ngIf="vehicleDetailsAvailable && hardFeaturesData.BuildDate">
                                                                {{
                                                                hardFeaturesData.BuildDate[0].substring(0,10)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Powertrain'|translate}}:</th>
                                                            <td>{{powerTrainSub}} {{powerTrainType}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Odometer Value in km'|translate}}:</th>
                                                            <td valign="top">{{ Odometer }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'PCM calibration file
                                                                initial'|translate}}:</th>
                                                            <td valign="top">{{ pcmCalibrationFile }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'PCM calibration file final'|translate}}:
                                                            </th>
                                                            <td valign="top">{{ pcmCalibrationFile }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table *ngIf="!sbdoService">
                                                    <tbody>
                                                        <tr>
                                                            <th width="170" align="left">{{'VIN'|translate}}:</th>
                                                            <td>{{ vinAvailable }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'model'|translate}}:</th>
                                                            <td id="vehicleDetailsModel"
                                                                *ngIf="vehicleDetailsAvailable && vehicleDetails['vehicle:displayName'][0]['vehicle:name']">
                                                                {{
                                                                vehicleDetails['vehicle:displayName'][0]['vehicle:name'][0]
                                                                }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Year'|translate}}:</th>
                                                            <td
                                                                *ngIf="vehicleDetailsAvailable && hardFeaturesData['vehicle:modelYear']">
                                                                {{
                                                                hardFeaturesData['vehicle:modelYear'][0]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Build'|translate}}:</th>
                                                            <td
                                                                *ngIf="vehicleDetailsAvailable && hardFeaturesData['vehicle:buildDate']">
                                                                {{
                                                                hardFeaturesData['vehicle:buildDate'][0].substring(0,10)}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Powertrain'|translate}}:</th>
                                                            <td>{{powerTrainSub}} {{powerTrainType}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Odometer Value in km'|translate}}:</th>
                                                            <td valign="top">{{ Odometer }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'PCM calibration file
                                                                initial'|translate}}:</th>
                                                            <td valign="top">{{ pcmCalibrationFile }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'PCM calibration file final'|translate}}:
                                                            </th>
                                                            <td valign="top">{{ pcmCalibrationFile }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div *ngIf="vehicleDetailsAvailable" class="sessionTitle">
                                                    {{'Header_C_DTC'|translate}}</div>
                                                <table width="100%" cellspacing="0" class="lateststatus"
                                                    *ngIf="vehicleDetailsAvailable && !dtcError">
                                                    <tbody>
                                                        <tr>
                                                            <th>Module</th>
                                                            <th align="left">DTC</th>
                                                            <th align="left">Type</th>
                                                            <th align="left">Failure</th>
                                                            <th align="left">Status</th>
                                                        </tr>
                                                        <tr *ngFor="let d of dtcList">
                                                            <td>
                                                                {{d.$.module}}
                                                            </td>
                                                            <td>
                                                                {{d.$.num}}
                                                            </td>
                                                            <td>
                                                                {{d.$.type}}
                                                            </td>
                                                            <td>
                                                                {{d.$.failure}}
                                                            </td>
                                                            <td>
                                                                {{d.$.status}}
                                                            </td>

                                                        </tr>

                                                    </tbody>
                                                </table>
                                                <div *ngIf="vehicleDetailsAvailable && dtcError">
                                                    No DTCs
                                                </div>
                                                <br>
                                                <div *ngIf="vehicleDetailsAvailable && showImportedDTCTable"
                                                    class="sessionTitle">{{'Header_H_DTC'|translate}}</div>
                                                <table width="100%" cellspacing="0" class="lateststatus"
                                                    *ngIf="vehicleDetailsAvailable && showImportedDTCTable">
                                                    <tbody>
                                                        <tr>
                                                            <th>Module</th>
                                                            <th align="left">DTC</th>
                                                            <th align="left">Type</th>
                                                            <th align="left">Failure</th>
                                                            <th align="left">Status</th>
                                                        </tr>
                                                        <tr *ngFor="let d of importedDTC">
                                                            <td>
                                                                {{d.$.module}}
                                                            </td>
                                                            <td>
                                                                {{d.$.num}}
                                                            </td>
                                                            <td>
                                                                {{d.$.type}}
                                                            </td>
                                                            <td>
                                                                {{d.$.failure}}
                                                            </td>
                                                            <td>
                                                                {{d.$.status}}
                                                            </td>

                                                        </tr>

                                                    </tbody>
                                                </table>
                                                <div class="sessionTitle" *ngIf="isMobileVan || alreadyResumedByAnotherUser" >{{'MobileVan Session Details'|translate}}</div>
                                                <table class="mobile-van-table" *ngIf="isMobileVan || alreadyResumedByAnotherUser">
                                                    <tbody>
                                                        <tr>
                                                            <th>{{'Original TimeStamp'|translate}}:</th>
                                                            <td>{{ createdTimeStamp }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Original DealerCode'|translate}}:</th>
                                                            <td>{{ originalDealerCode }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Original Username'|translate}}:</th>
                                                            <!-- Fixed variable below (was createdTimeStamp) -->
                                                            <td>{{ originalUsername }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Updated TimeStamp'|translate}}:</th>
                                                            <td>{{ updatedTimeStamp }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Reassigned Username'|translate}}:</th>
                                                            <!-- Fixed variable below (was createdTimeStamp) -->
                                                            <td>{{ ReassignedUsername }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Reassigned DealerCode'|translate}}:</th>
                                                            <td>{{ reassignedDealerCode }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <hr>
                                                <br>
                                                <table class='sessionOpenTbl' *ngIf="showMultiplesessionTable">
                                                    <tbody>
                                                        <ng-container
                                                            *ngFor="let sessionOpen of sessionOpenArray; index as i">
                                                            <tr>
                                                                <th align="left">{{'Previous Session'|translate}}:</th>
                                                                <td *ngIf="sessionError">{{
                                                                    sessionDetails.previousSession}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th align="left">{{'Session Opened'|translate}}:</th>
                                                                <td *ngIf="sessionError">{{
                                                                    sessionOpen.substring(0,10)}}&nbsp;{{
                                                                    sessionOpen.substring(11,19)}} [UK-Time]</td>
                                                            </tr>
                                                            <tr>
                                                                <th align="left">{{'Source'|translate}}
                                                                    :
                                                                </th>
                                                                <td *ngIf="sessionError">{{ sessionDetails.source}}</td>
                                                            </tr>
                                                            <tr *ngIf='!isSessionCloseTagPresent'>
                                                                <th align="left">{{'Session
                                                                    Suspended'|translate}}:</th>
                                                                <td>{{
                                                                    lastWfsTime.substring(0,10)}}&nbsp;{{
                                                                    lastWfsTime.substring(11,19)}} [UK-Time]</td>
                                                            </tr>
                                                            <tr
                                                                *ngIf="isSessionCloseTagPresent && sessionCloseArray[i].state =='suspended'">
                                                                <th align="left">{{'Session
                                                                    Suspended'|translate}}:</th>
                                                                <td *ngIf="sessionCloseArray[i].time !='nil'">{{
                                                                    sessionCloseArray[i].time.substring(0,10)}}&nbsp;{{
                                                                    sessionCloseArray[i].time.substring(11,19)}} [UK-Time]</td>
                                                                <td *ngIf="sessionCloseArray[i].time =='nil'">
                                                                    -------
                                                                </td>
                                                            </tr>
                                                            <tr
                                                                *ngIf="isSessionCloseTagPresent && sessionCloseArray[i].state =='closed'">
                                                                <th align="left">{{'Session
                                                                    Closed'|translate}}:</th>
                                                                <td>{{
                                                                    sessionCloseArray[i].time.substring(0,10)}}&nbsp;{{
                                                                    sessionCloseArray[i].time.substring(11,19)}} [UK-Time]</td>
                                                            </tr>
                                                            <th colspan="2" align="left">{{'Dealership
                                                                Details'|translate}}</th>
                                                            <!-- </tr> -->
                                                            <tr>
                                                                <td *ngIf="sessionError">{{ dealerDetails.etisCode }}
                                                                </td>
                                                                <td *ngIf="sessionError">{{ dealerDetails.country }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th colspan="2" align="left">{{'Technician
                                                                    Details'|translate}}</th>
                                                            </tr>
                                                            <tr>
                                                                <td *ngIf="sessionError">{{ techDetails.cdsId }}</td>
                                                                <td *ngIf="sessionError">{{ techDetails.country
                                                                    }}&nbsp;{{
                                                                    techDetails.language }}</td>
                                                            </tr>
                                                            <hr>
                                                        </ng-container>
                                                    </tbody>
                                                </table>
                                                <table *ngIf='sessionClosed && !showMultiplesessionTable'>
                                                    <tbody>
                                                        <tr>
                                                            <th align="left">{{'Previous Session'|translate}}:</th>
                                                            <td *ngIf="sessionError">{{ sessionDetails.previousSession}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Session Opened'|translate}}:</th>
                                                            <td *ngIf="sessionError">{{
                                                                sessionDetails.sessionOpen.substring(0,10)}}&nbsp;{{
                                                                sessionDetails.sessionOpen.substring(11,19)}} [UK-Time]</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Source'|translate}}
                                                                :
                                                            </th>
                                                            <td *ngIf="sessionError">{{ sessionDetails.source}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Session
                                                                Closed'|translate}}:</th>
                                                            <td>{{
                                                                closedTime.substring(0,10)}}&nbsp;{{
                                                                closedTime.substring(11,19)}} [UK-Time]</td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="2" align="left">{{'Dealership
                                                                Details'|translate}}</th>
                                                        </tr>
                                                        <tr>
                                                            <td *ngIf="sessionError">{{ dealerDetails.etisCode }}</td>
                                                            <td *ngIf="sessionError">{{ dealerDetails.country }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="2" align="left">{{'Technician
                                                                Details'|translate}}</th>
                                                        </tr>
                                                        <tr>
                                                            <td *ngIf="sessionError">{{ techDetails.cdsId }}</td>
                                                            <td *ngIf="sessionError">{{ techDetails.country }}&nbsp;{{
                                                                techDetails.language }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <hr>
                                                <br>
                                            </div>
                                            <div style="display: block;" id="indictmentSection">
                                                <hr>

                                                <p class="head">{{'Indictment'|translate}}</p>

                                                <hr>
                                                <br>
                                                <table *ngIf="indictmentAvailable">
                                                    <tbody>
                                                        <tr>
                                                            <th align="left">{{'Diagnostic Method'|translate}}:</th>
                                                            <td *ngIf="indictmentDataAvailable">{{ dMethod }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Route'|translate}}:</th>
                                                            <td valign="top">{{ route }}</td>
                                                        </tr>
                                                        <tr>

                                                            <th align="left">{{'Component'|translate}}:</th>


                                                            <td valign="top">{{indictmentDetails.component[0]._}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Warranty Component
                                                                Classification'|translate}}:</th>
                                                            <td valign="top" *ngIf="indictmentDataAvailable1">{{wcc}}
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="indictmentFinisCode">
                                                            <th align="left">{{'FINIS Code'|translate}}:</th>
                                                            <td valign="top">{{indictmentDetails.finisCode[0].$.value}}
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="indictmentLabourAvailable">
                                                            <th align="left">{{'Labor only'|translate}}:</th>
                                                            <td valign="top"><img id="teenytinytick"
                                                                    src="assets/images/teenytinytick.gif" width="15"
                                                                    height="10">
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Warranty Dealer Code'|translate}}:</th>
                                                            <td valign="top">
                                                                {{indictmentDetails.dealer[0].$.warrantyCode}}
                                                            </td>
                                                        </tr>
                                                        <tr>

                                                            <th align="left">{{'Repair Validation Code'|translate}}:
                                                            </th>
                                                            <td valign="top">
<!--                                                                {{rvcMsg|translate}}-->
                                                              <div class="row">
                                                                <div class="col-sm-3">
                                                                  <div *ngIf="indictmentDataAvailable2">
                                                                    {{rvcMsg|translate}}
                                                                  </div>
                                                                </div>
                                                                <div class="col-sm-9">
                                                                  <div *ngIf="norvcMsgDec" class="norvg-msg">
                                                                    <p style="font-weight: 600;height: 20px;">{{'norvc_session_viewer_desc_msg' | translate}}</p>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="BatteryCodeValue != '' ">
                                                            <th align="left">Midtronics Code:
                                                            </th>
                                                            <td valign="top">
                                                                {{BatteryCodeValue}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th valign="top" align="left">{{'Failure Notes'|translate}}
                                                            </th>
                                                            <td> {{ failureNote }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Repair Procedures'|translate}}:</th>
                                                            <td>{{repaircount}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Post Repair Procedures'|translate}}:
                                                            </th>
                                                            <td valign="top">
                                                                {{postcount}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th valign="top" align="left">{{'Repair
                                                                Information'|translate}}</th>
                                                            <td valign="top" class="relink"><a
                                                                    (click)="viewProc(repairLink,'','');">{{repairLink}}</a>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="2" valign="top" align="left">{{'Claim
                                                                Coding'|translate}}</th>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Causal Part'|translate}}</th>
                                                            <td valign="top" *ngIf="claimCodingAvilable">{{
                                                                claimCoding.causalPart }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Condition Code'|translate}}</th>
                                                            <td valign="top" *ngIf="claimCodingAvilable">{{
                                                                claimCoding.conditionCode }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="3" valign="top" align="left">{{'Warranty
                                                                Kit'|translate}}</th>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="2" align="left">{{'FINIS Code'|translate}}</th>
                                                            <th align="left">{{'Quantity'|translate}}</th>
                                                        </tr>
                                                        <tr *ngFor="let i of warrantyKit">
                                                            <td colspan="2" *ngIf="warrantyAvailable">{{ i.partNumber }}
                                                            </td>
                                                            <td *ngIf="warrantyAvailable">{{ i.quantity }}</td>
                                                        </tr>

                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="3" valign="top" align="left">{{'Parts
                                                                Required'|translate}}</th>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'FINIS Code'|translate}}</th>
                                                            <th align="left">{{'Part Number'|translate}}</th>
                                                            <th align="left">{{'Quantity'|translate}}</th>
                                                        </tr>
                                                        <tr *ngFor="let i of partsListing">
                                                            <td *ngIf="partsAvailable">{{ i.partNumber }}</td>
                                                            <td *ngIf="partsAvailable">{{ i.realPartNumber }}</td>
                                                            <td *ngIf="partsAvailable">{{ i.quantity }}</td>
                                                        </tr>


                                                        <tr>
                                                            <td colspan="2">{{'Parts listed may not represent a complete
                                                                parts repair list'|translate}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="2" align="left">{{'Labour Times'|translate}}
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">{{'Operation number'|translate}} *</th>

                                                            <th align="left">{{'Time'|translate}}</th>


                                                        </tr>
                                                        <tr *ngFor="let i of labourTimes">
                                                            <td *ngIf="labourTimeAvailable">{{ i.operationNumber}}</td>
                                                            <td *ngIf="labourTimeAvailable">{{ i.time }}</td>

                                                        </tr>

                                                        <tr>
                                                            <td colspan="2">{{'vehicle session view
                                                                information'|translate}} *</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th valign="top" align="left">{{'Warranty
                                                                Controls'|translate}}</th>
                                                        </tr>
                                                        <div *ngFor="let i of warrantyControls">
                                                            <tr>
                                                                <td>&nbsp;</td>
                                                            </tr>
                                                            <tr>
                                                                <th valign="top" align="left">{{'Warranty
                                                                    Control'|translate}}</th>
                                                            </tr>
                                                            <tr>
                                                                <th valign="top" align="left">{{'Warranty Control
                                                                    Id'|translate}}</th>
                                                                <td>{{ i.$.id }}</td>
                                                            </tr>
                                                            <tr>
                                                                <th valign="top" align="left">{{'Container Document
                                                                    Uid'|translate}}</th>
                                                                <td>{{ i.$.containerDocumentUid }}</td>
                                                            </tr>
                                                            <tr>
                                                                <th valign="top" align="left">{{'Container Position
                                                                    Uid'|translate}}</th>
                                                                <td>{{ i.$.containerPositionUid }}</td>
                                                            </tr>
                                                            <tr>
                                                                <th valign="top" align="left">{{'Outline Position
                                                                    Uid'|translate}}</th>
                                                                <td>{{ i.$.outlinePositionUid }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>&nbsp;</td>
                                                            </tr>
                                                            <tr>
                                                                <th valign="top" align="left">{{'Diagnostic
                                                                    Method'|translate}}</th>
                                                                <th valign="top" align="left">{{'Method'|translate}}
                                                                </th>
                                                                <td>{{ i.warrantyControlDiagnosticMethod[0].$.method }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>&nbsp;</td>
                                                            </tr>
                                                            <tr>
                                                                <th valign="top" align="left">{{'Market Country
                                                                    Codes'|translate}}</th>
                                                                <th valign="top" align="left">{{'Is list
                                                                    inclusive'|translate}}?</th>
                                                                <td>{{ i.markets[0].$.inclusive }}</td>
                                                            </tr>
                                                            <tr>
                                                                <th align="left">{{'Code'|translate}}</th>
                                                                <th align="left">{{'Match'|translate}}</th>
                                                            </tr>

                                                            <tr *ngFor="let r of i.markets[0].market">
                                                                <td>{{ r.$.country }}</td>
                                                                <td>{{ r.$.match }}</td>
                                                            </tr>

                                                            <tr>
                                                                <td>&nbsp;</td>
                                                            </tr>
                                                            <tr>
                                                                <th valign="top" align="left">{{'User
                                                                    Groups'|translate}}</th>
                                                                <th valign="top" align="left">{{'Is list
                                                                    inclusive'|translate}}?</th>
                                                                <td>{{ i.userGroups[0].$.inclusive }}</td>
                                                            </tr>
                                                            <tr>
                                                                <th align="left">{{'Name'|translate}}</th>
                                                                <th align="left">{{'Match'|translate}}</th>
                                                            </tr>

                                                            <tr *ngFor="let r of i.userGroups[0].userGroup">
                                                                <td>{{ r.$.name }}</td>
                                                                <td>{{ r.$.match }}</td>
                                                            </tr>
                                                            <tr>
                                                                <th colspan="2" valign="top" align="left">
                                                                    {{'Actions'|translate}}</th>
                                                            </tr>
                                                            <tr>
                                                                <th align="left">{{'ID'|translate}}</th>
                                                                <th align="left">{{'Proceed with action'|translate}}
                                                                </th>
                                                            </tr>
                                                            <tr *ngFor="let r of i.actions[0].action">
                                                                <td>{{ r.$.id }}</td>
                                                                <td>{{ r.$.do }}</td>
                                                            </tr>
                                                        </div>
                                                    </tbody>
                                                </table>
                                                <table *ngIf="!indictmentAvailable && BatteryCodeValue != '' " class="Batterycode-table">
                                                    <tbody>
                                                        <tr>
                                                            <th>Midtronics code:</th>
                                                            <td>{{ BatteryCodeValue }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style="display: none;" id="diagnosticSection">
                                                <hr>

                                                <p class="head">{{'Diagnostic'|translate}} </p>

                                                <hr>
                                                <div *ngFor="let i of diagnosticDetails, let parentIndex=index">

                                                    <div class="sessionTitle">{{'Diagnostic Sequence'|translate}}
                                                        {{i[0]}}</div>

                                                    <div class="sessionTitle">{{'Symptoms Selected'|translate}}</div>
                                                    <div *ngFor="let s of i[1]">
                                                        <ul>
                                                            <li>{{s.title}}<br>( {{s.gradexId}} )</li>
                                                        </ul>
                                                    </div>
                                                    <div class="sessionTitle"
                                                        *ngIf="diagnosisAvailable && i.length > 2">{{'Tests
                                                        Offered'|translate}}</div>
                                                    <table width="100%" cellspacing="0" class="lateststatus"
                                                        *ngIf="diagnosisAvailable && i.length > 2">
                                                        <tbody>
                                                            <tr>
                                                                <th valign="top">{{'Sequence'|translate}}</th>
                                                                <th valign="top" align="left">{{'Title'|translate}}</th>
                                                                <th align="left">{{'Resource ID'|translate}}</th>

                                                                <th valign="top" align="left">{{'Type'|translate}}</th>


                                                                <th valign="top" align="left">{{'Rule'|translate}}</th>
                                                            </tr>
                                                            <tr *ngFor="let p of i[2]">
                                                                <td valign="top" class="center">{{p.seq}}</td>
                                                                <td valign="top">{{p.title}}</td>
                                                                <td valign="top" class="relink"><a
                                                                        (click)="viewProc(p.resourceId,p.type,p.gradexRule.symptomMap);">{{p.resourceId}}</a>
                                                                </td>
                                                                <td valign="top">{{p.type}}</td>
                                                                <td valign="top">
                                                                    <table width="100%" cellspacing="0"
                                                                        class="lateststatus">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{{'Symptom Map'|translate}}</td>
                                                                                <td>{{p.gradexRule.symptomMap}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>{{'Rule'|translate}}</td>
                                                                                <td>{{p.gradexRule.rule}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>{{'Timestamp'|translate}}</td>
                                                                                <td>{{p.gradexRule.timeStamp |
                                                                                    date:'yyyy-MM-dd
                                                                                    HH:mm:ss':'GMT'}}&nbsp;GMT</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div *ngIf="diagnosisAvailable && i.length > 2">
                                                        <div class="sessionTitle">{{'Tests Executed'|translate}}</div>
                                                        <table width="100%" cellspacing="0" class="lateststatus">
                                                            <tbody>
                                                                <tr>
                                                                    <th>{{'Sequence'|translate}}</th>
                                                                    <th align="left">{{'Title'|translate}}</th>
                                                                    <th align="left">{{'Resource ID'|translate}}</th>
                                                                    <th align="left">{{'Start'|translate}}</th>
                                                                    <th align="left">{{'End'|translate}}</th>
                                                                    <th align="left">{{'Outcome'|translate}}</th>
                                                                    <th>{{'Details'|translate}}</th>
                                                                </tr>
                                                                <ng-container *ngFor="let i of i[3], let ind=index">
                                                                    <tr *ngIf="diagnosisOffered">
                                                                        <td valign="top" align="center">{{ i.seq }}</td>
                                                                        <td valign="top">{{ i.title }}</td>
                                                                        <td valign="top" class="relink"><a
                                                                                (click)="viewProc(i.rId,i.type,'');">{{
                                                                                i.rId }}</a></td>
                                                                        <td valign="top"> {{ i.start | date:'yyyy-MM-dd
                                                                            HH:mm:ss':'GMT' }}</td>
                                                                        <td valign="top"> {{ i.end | date:'yyyy-MM-dd
                                                                            HH:mm:ss':'GMT'}}</td>
                                                                        <td valign="top">{{ i.outcome }}</td>
                                                                        <td><input
                                                                                (click)="showhideOTXDiagnosticDetails(ind,parentIndex)"
                                                                                type="button"
                                                                                value="{{'Details'|translate}}"></td>

                                                                    </tr>
                                                                    <tr id='otxdetails'
                                                                        *ngIf="diagnosticDetails[parentIndex][5][ind] == 1 && showOTXScreenDetails">
                                                                        <td colspan="7">
                                                                            <table width="100%" cellspacing="0"
                                                                                cellpadding="1" class="lateststatus">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <th>Title</th>
                                                                                        <th>Start</th>
                                                                                        <th>Question</th>
                                                                                        <th>Outcome/Parameter</th>
                                                                                        <th>Data</th>
                                                                                    </tr>
                                                                                    <tr
                                                                                        *ngFor="let j of otxScreenHistoryDetails">
                                                                                        <td>{{j.title}}
                                                                                        </td>
                                                                                        <td>{{j.time |
                                                                                            date:'HH:mm:ss':'GMT'}}
                                                                                        </td>
                                                                                        <td>
                                                                                            {{j.question}}
                                                                                        </td>

                                                                                        <td>{{j.outcome}}
                                                                                        </td>
                                                                                        <td></td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                    <tr id='otxdetails'
                                                                        *ngIf="diagnosticDetails[parentIndex][5][ind] == 1 && !showOTXScreenDetails">
                                                                        No Data Available
                                                                    </tr>
                                                                </ng-container>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div *ngIf="!diagnosisAvailable || i.length === 2">{{'No diagnostic
                                                        procedures'|translate}}</div>
                                                </div>
                                            </div>

                                            <div style="display: block;" id="repairSection">
                                                <hr>
                                                <p class="head">{{'Repair'|translate}}</p>

                                                <hr>
                                                <div *ngIf="repairAvailable">
                                                    <div class="sessionTitle">{{'Repair Procedures Offered'|translate}}
                                                    </div>
                                                    <table width="100%" cellspacing="0" class="lateststatus">
                                                        <tbody>
                                                            <tr>
                                                                <th valign="top">{{'Sequence'|translate}}</th>
                                                                <th valign="top" align="left">{{'Title'|translate}}</th>
                                                                <th align="left">{{'Resource ID'|translate}}</th>

                                                                <th valign="top" align="left">{{'Type'|translate}}</th>


                                                                <th valign="top" align="left">{{'Rule'|translate}}</th>
                                                            </tr>
                                                            <tr *ngFor="let i of repairList">
                                                                <td valign="top" align="center">{{ i.seq }}</td>
                                                                <td valign="top">{{ i.title }}</td>
                                                                <td valign="top" class="relink"><a
                                                                        (click)="viewProc(i.resourceId,i.type,i.gradexRule.symptomMap);">{{
                                                                        i.resourceId }}</a></td>
                                                                <td valign="top">{{ i.type }}</td>
                                                                <td valign="top">
                                                                    <table width="100%" cellspacing="0"
                                                                        class="lateststatus">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{{'Symptom Map'|translate}}</td>
                                                                                <td>{{ i.gradexRule.symptomMap }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>{{'Rule'|translate}}</td>
                                                                                <td>{{ i.gradexRule.rule }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>{{'Timestamp'|translate}}</td>
                                                                                <td>{{i.gradexRule.timeStamp |
                                                                                    date:'yyyy-MM-dd
                                                                                    HH:mm:ss':'GMT'}}&nbsp;GMT</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div *ngIf="repairExecutedAvailable">
                                                    <div class="sessionTitle">{{'Repair Procedures Executed'|translate}}
                                                    </div>
                                                    <table width="100%" cellspacing="0" class="lateststatus">
                                                        <tbody>
                                                            <tr>
                                                                <th>{{'Sequence'|translate}}</th>
                                                                <th align="left">{{'Title'|translate}}</th>
                                                                <th align="left">{{'Resource ID'|translate}}</th>
                                                                <th align="left">{{'Start'|translate}}</th>
                                                                <th align="left">End</th>
                                                                <th align="left">Outcome</th>
                                                                <th>{{'Details'|translate}}</th>
                                                            </tr>
                                                            <ng-container
                                                                *ngFor="let i of repairExecuted, let ind=index">
                                                                <tr>
                                                                    <td valign="top" align="center">{{ i.seq }}</td>
                                                                    <td valign="top">{{ i.title }}</td>
                                                                    <td valign="top" class="relink"><a
                                                                            (click)="viewProc(i.rId,i.type,'');">{{
                                                                            i.rId
                                                                            }}</a></td>
                                                                    <td valign="top"> {{ i.start | date:'yyyy-MM-dd
                                                                        HH:mm:ss':'GMT' }}</td>
                                                                    <td valign="top"> {{ i.end | date:'yyyy-MM-dd
                                                                        HH:mm:ss':'GMT'}}</td>
                                                                    <td valign="top">{{ i.outcome }}</td>
                                                                    <td><input
                                                                            (click)="fetchRepairTestExecutedOTXDetails(ind)"
                                                                            type="button"
                                                                            value="{{'Details'|translate}}"></td>

                                                                </tr>
                                                                <tr *ngIf="showhideRepair[ind] && isRepairDetails">
                                                                    <td colspan="7">
                                                                        <table width="100%" cellspacing="0"
                                                                            cellpadding="1" class="lateststatus">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <th>Title</th>
                                                                                    <th>Start</th>
                                                                                    <th>Question</th>
                                                                                    <th>Outcome/Parameter</th>
                                                                                    <th>Data</th>
                                                                                </tr>
                                                                                <tr
                                                                                    *ngFor="let j of repairOTXHistoryDetails">
                                                                                    <td>{{j.title}}
                                                                                    </td>
                                                                                    <td>{{j.time |
                                                                                        date:'HH:mm:ss':'GMT'}}
                                                                                    </td>
                                                                                    <td>
                                                                                        {{j.question}}
                                                                                    </td>

                                                                                    <td>{{j.outcome}}
                                                                                    </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                                <tr *ngIf="showhideRepair[ind] && !isRepairDetails">
                                                                    No Data Available
                                                                </tr>
                                                            </ng-container>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div *ngIf="postRepairAvailable">
                                                    <div class="sessionTitle">{{'Post Repair Procedures
                                                        Offered'|translate}}</div>
                                                    <table width="100%" cellspacing="0" class="lateststatus">
                                                        <tbody>
                                                            <tr>
                                                                <th valign="top">{{'Sequence'|translate}}</th>
                                                                <th valign="top" align="left">{{'Title'|translate}}</th>
                                                                <th align="left">{{'Resource ID'|translate}}</th>
                                                                <th valign="top" align="left">{{'Type'|translate}}</th>
                                                                <th valign="top" align="left">{{'Rule'|translate}}</th>
                                                            </tr>
                                                            <tr *ngFor="let i of postRepairList">
                                                                <td valign="top" align="center">{{ i.seq }}</td>
                                                                <td valign="top">{{ i.title }}</td>
                                                                <td valign="top" class="relink"><a
                                                                        (click)="viewProc(i.resourceId ,i.type,i.gradexRule.symptomMap);">{{
                                                                        i.resourceId }}</a></td>
                                                                <td valign="top">{{ i.type }}</td>
                                                                <td valign="top">
                                                                    <table width="100%" cellspacing="0"
                                                                        class="lateststatus">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{{'Symptom Map'|translate}}</td>
                                                                                <td>{{ i.gradexRule.symptomMap }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>{{'Rule'|translate}}</td>
                                                                                <td>{{ i.gradexRule.rule }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>{{'Timestamp'|translate}}</td>
                                                                                <td>{{i.gradexRule.timeStamp |
                                                                                    date:'yyyy-MM-dd
                                                                                    HH:mm:ss':'GMT'}}&nbsp;GMT</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div *ngIf="postrepairExecutedAvailable">
                                                        <div class="sessionTitle">{{'Post-Repair Procedures
                                                            Executed'|translate}}</div>
                                                        <table width="100%" cellspacing="0" class="lateststatus">
                                                            <tbody>
                                                                <tr>
                                                                    <th>{{'Sequence'|translate}}</th>
                                                                    <th align="left">{{'Title'|translate}}</th>
                                                                    <th align="left">{{'Resource ID'|translate}}</th>
                                                                    <th align="left">{{'Start'|translate}}</th>
                                                                    <th align="left">End</th>
                                                                    <th align="left">Outcome</th>
                                                                    <th>{{'Details'|translate}}</th>
                                                                </tr>
                                                                <ng-container
                                                                    *ngFor="let i of postrepairExecuted, let ind=index">
                                                                    <tr>
                                                                        <td valign="top" align="center">{{ i.seq }}</td>
                                                                        <td valign="top">{{ i.title }}</td>
                                                                        <td valign="top" class="relink"><a
                                                                                (click)="viewProc(i.rId,i.type,'');">{{
                                                                                i.rId }}</a></td>
                                                                        <td valign="top"> {{ i.start | date:'yyyy-MM-dd
                                                                            HH:mm:ss':'GMT' }}</td>
                                                                        <td valign="top"> {{ i.end | date:'yyyy-MM-dd
                                                                            HH:mm:ss':'GMT'}}</td>
                                                                        <td valign="top">{{ i.outcome }}</td>
                                                                        <td><input
                                                                                (click)="fetchPostRepairTestExecutedOTXDetails(ind)"
                                                                                type="button"
                                                                                value="{{'Details'|translate}}"></td>

                                                                    </tr>
                                                                    <tr
                                                                        *ngIf="showhidePostRepair[ind] && isPostRepairDetails">
                                                                        <td colspan="7">
                                                                            <table width="100%" cellspacing="0"
                                                                                cellpadding="1" class="lateststatus">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <th>Title</th>
                                                                                        <th>Start</th>
                                                                                        <th>Question</th>
                                                                                        <th>Outcome/Parameter</th>
                                                                                        <th>Data</th>
                                                                                    </tr>
                                                                                    <tr
                                                                                        *ngFor="let j of postRepairOTXHistoryDetails">
                                                                                        <td>{{j.title}}
                                                                                        </td>
                                                                                        <td>{{j.time |
                                                                                            date:'HH:mm:ss':'GMT'}}
                                                                                        </td>
                                                                                        <td>
                                                                                            {{j.question}}
                                                                                        </td>

                                                                                        <td>{{j.outcome}}
                                                                                        </td>
                                                                                        <td></td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                    <tr
                                                                        *ngIf="showhidePostRepair[ind] && !isPostRepairDetails">
                                                                        No Data Available
                                                                    </tr>
                                                                </ng-container>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <!-- <div class="sessionTitle">Post-Repair Procedures Executed</div>
                                            <table width="100%" cellspacing="0" class="lateststatus">
                                                <tbody>
                                                    <tr>
                                                        <th>{{'Sequence'|translate}}</th>
                                                        <th align="left">{{'Title'|translate}}</th>
                                                        <th align="left">{{'Resource ID'|translate}}</th>
                                                        <th align="left">{{'Start'|translate}}</th>
                                                        <th align="left">End</th>
                                                        <th align="left">Outcome</th>
                                                        <th>Details</th>
                                                    </tr>
                                                    <tr>
                                                        <td valign="top" align="center">1</td>
                                                        <td valign="top">Transmission Control Module (TCM) Adaptive
                                                            Learning</td>
                                                        <td valign="top"><a onclick="viewProc('G1502158', 'SPA');"
                                                                href="#">G1502158</a></td>
                                                        <td valign="top"> 2020-01-01 09:33:37</td>
                                                        <td valign="top"> 2020-01-01 09:46:14</td>
                                                        <td valign="top">passed</td>
                                                        <td><input onclick="showhide('N1E39C')" type="button"
                                                                value="Details"></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="7">
                                                            <div style="display: none" id="N1E39C">
                                                                <table width="100%" cellspacing="0" cellpadding="1"
                                                                class="lateststatus">
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Step</th>
                                                                            <th align="left">{{'Title'|translate}}</th>
                                                                            <th align="left">{{'Start'|translate}}</th>
                                                                            <th align="left">Question</th>
                                                                            <th align="left">Outcome/Parameter</th>
                                                                            <th align="left">Data</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td valign="top" align="center">0</td>
                                                                            <td valign="top">G1502158 : Transmission
                                                                                Control Module (TCM) Adaptive Learning
                                                                            </td>
                                                                            <td valign="top">09:46:12</td>
                                                                            <td valign="top"></td>
                                                                            <td valign="top"></td>
                                                                            <td valign="top">
                                                                                <div class="indented">
                                                                                    <i>IDSButton:
                                                                                    </i>filename=http://127.0.0.1:8888/spa/getContent.do?type=spa-ids-tool&amp;id=G1502159&amp;language=EN&amp;country=USA
                                                                                    pressed=2 text=Transmission Static
                                                                                    Adaptive Learning
                                                                                </div>
                                                                                <input type="button" value="Details"
                                                                                    onclick="var a = document.getElementById('N1EFD9');if (a.style.display=='none') {a.style.display='block';} else {a.style.display='none';}">
                                                                                <div style="display: none" id="N1EFD9">
                                                                                    <table width="100%" cellspacing="0"
                                                                                        cellpadding="1" class="lateststatus">
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <th>ToolName</th>
                                                                                                <th>ToolEntry</th>
                                                                                                <th>ToolExit</th>
                                                                                                <th>Data</th>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td valign="top">
                                                                                                    FT_AT_TEACHIN_03
                                                                                                </td>
                                                                                                <td valign="top">
                                                                                                    2020-01-01T09:33:50
                                                                                                </td>
                                                                                                <td valign="top">
                                                                                                    2020-01-01T09:46:03
                                                                                                </td>
                                                                                                <td></td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                                <br>
                                                                                <br>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <br>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table> -->
                                                </div>

                                                <div *ngIf="!repairAvailable">{{'No repair procedures'|translate}}</div>
                                                <br>
                                                <br>
                                                <div *ngIf="!postRepairAvailable">{{'No post repair
                                                    procedures'|translate}}</div>

                                            </div>
                                            <div style="display: none;" id="moduleSoftwareSection">
                                                <hr>
                                                <p class="head">{{'Module and Software'|translate}}</p>
                                                <hr>
                                                <div *ngIf='moduleDetailsAvailable && sbdoService'>
                                                    <div class="sessionTitle">{{'Fitted Modules'|translate}}</div>
                                                    <div *ngFor="let module of moduleSoftwareDetails">
                                                        <div class="dataEcu">{{module.Name}},
                                                            {{module.Address}},
                                                            {{module.PhysicalNetworkName}}</div>
                                                        <table style="margin-top: 0mm; margin-bottom: 5mm">
                                                            <tbody>
                                                                <tr>
                                                                    <th style="text-align: left;">{{'Date'|translate}}:
                                                                    </th>
                                                                    <td *ngIf="sessionAvailable">{{
                                                                        sessionDetails.sessionOpen}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th style="text-align: left;">{{'State Change
                                                                        Date'|translate}}:
                                                                    </th>
                                                                    <td>{{module.StateChangeDate}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <table class="lateststatus"
                                                            *ngFor='let m of module.DiagnosticIdentifierResponses'>
                                                            <tbody>
                                                                <tr style="text-align:center">
                                                                    <th>DID</th>

                                                                    <th>{{'Type'|translate}}</th>



                                                                    <th>{{'Number'|translate}}</th>
                                                                    <th>{{'Vehicle Update'|translate}}</th>
                                                                </tr>


                                                                <tr *ngFor='let p of m.DiagnosticIdentifierResponse'>

                                                                    <td>{{p.Identifier}}</td>
                                                                    <td style="text-transform: uppercase;">{{p.Type}}
                                                                    </td>
                                                                    <td *ngIf="p.ResponseMessage">
                                                                        {{p.ResponseMessage[0].Response}}</td>
                                                                    <td *ngIf="!p.ResponseMessage"></td>
                                                                    <td></td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div *ngIf='moduleDetailsAvailable && !sbdoService'>
                                                    <div class="sessionTitle">{{'Fitted Modules'|translate}}</div>
                                                    <div>


                                                        <table class="lateststatus">
                                                            <tbody>
                                                                <tr style="text-align:center">
                                                                    <th>Response</th>
                                                                    <th>Acronym</th>
                                                                    <th>Description</th>
                                                                    <th>Assembly Part Number</th>
                                                                    <th>{{'Details'|translate}}</th>
                                                                </tr>
                                                                <tr
                                                                    *ngFor="let module of moduleSoftwareDetails,let ind=index">
                                                                    <td style="color: green;"
                                                                        *ngIf="module.$.connected == 'true'">
                                                                        Responded</td>
                                                                    <td style="color: red;"
                                                                        *ngIf="module.$.connected == 'false'">
                                                                        Not Responded</td>
                                                                    <td>{{module.$.id}}</td>
                                                                    <td>{{module.$.title}}</td>
                                                                    <td *ngIf="module.$.connected">
                                                                        {{module.$.spn}} </td>

                                                                    <td
                                                                        *ngIf="module.$.connected =='true' && moduleArray[ind]">
                                                                        <table style="width: 100%;">
                                                                            <tbody>
                                                                                <tr style="text-align:center">
                                                                                    <th>Name</th>
                                                                                    <th>Value</th>

                                                                                </tr>
                                                                                <tr *ngFor="let value of vehicleValue">
                                                                                    <td
                                                                                        *ngIf="value.$.module == module.$.id && value.$.name !='MODULE_RESPONDED'">
                                                                                        {{value.$.name}}
                                                                                    </td>
                                                                                    <td
                                                                                        *ngIf="value.$.module == module.$.id && value.$.name !='MODULE_RESPONDED'">
                                                                                        {{value._}}</td>
                                                                                </tr>


                                                                            </tbody>
                                                                        </table>
                                                                    </td>

                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="display: none" id="systemSnapshotSection">
                                                <hr>
                                                <p class="head">{{'System Snapshot'|translate}}</p>
                                                <hr>
                                                <div class="sessionTitle">{{'Feedback'|translate}}</div>
                                                <div *ngFor="let entries of feedbackDisplays | slice:0:length">
                                                    <div>{{entries}}.xsd</div>
                                                </div>
                                                <br>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <th align="left">{{'Session Opened'|translate}} :</th>
                                                            <td *ngIf="sessionError">{{
                                                                sessionDetails.sessionOpen.substring(0,10)}}&nbsp;{{
                                                                sessionDetails.sessionOpen.substring(11,19)}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div class="sessionTitle" style="font-weight: bold;color: #003F87">
                                                    {{'Software'|translate}}</div>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <th>{{'Gfdrs Version'|translate}}</th>
                                                            <td>{{GFDRS}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Targeting Engine Version'|translate}}</th>
                                                            <td>{{targetingEngineVersion}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Java Version'|translate}}</th>
                                                            <td>{{javaVersion}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Firmware Version in VCM'|translate}}</th>
                                                            <td *ngIf="vcmVersion != 'unknown'">{{vcmVersion |
                                                                slice:13}}</td>
                                                            <td *ngIf="vcmVersion == 'unknown'">{{vcmVersion}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{'Firmware Version in VMM'|translate}}</th>
                                                            <td *ngIf="vmmVersion != 'unknown'">{{vmmVersion |
                                                                slice:13}}</td>
                                                            <td *ngIf="vmmVersion == 'unknown'">{{vmmVersion}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>OSVersion</th>
                                                            <td>{{osVersion}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>OSName</th>
                                                            <td>{{osName}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Memory Information</th>
                                                            <td>{{memoryInfo}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>CPU Information</th>
                                                            <td>{{cpuInfo}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Device Serial Number</th>
                                                            <td>{{deviceSerialNo}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style="display: none" id="dataCollectionSection">
                                                <hr>
                                                <p class="head">{{'Data Collection'|translate}}</p>
                                                <hr>
                                                <br>
                                                <table cellspacing="0" cellpadding="2" class="lateststatus"
                                                    *ngIf="dataCollectionAvailable">
                                                    <tbody>
                                                        <tr>
                                                            <th align="left">{{'Name'|translate}}</th>
                                                            <th align="left">{{'Value'|translate}}</th>
                                                        </tr>
                                                        <tr *ngFor="let i of valueArray2">
                                                            <th style="font-weight: initial;" align="left">{{i[0]}}</th>
                                                            <td>{{i[1]}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <br>
                                                <table cellspacing="0" cellpadding="2" class="lateststatus"
                                                    *ngIf="dataCollectionAvailable">
                                                    <tbody>
                                                        <tr>
                                                            <th align="left"><b>{{'Module'|translate}}</b></th>
                                                            <th align="left">{{'Name'|translate}}</th>
                                                            <th align="left">{{'Value'|translate}}</th>
                                                        </tr>
                                                        <tr *ngFor="let i of valueArray1">
                                                            <td>{{i[0]}}</td>
                                                            <td>{{i[1]}}</td>
                                                            <td>{{i[2]}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style="display: none" id="workflowSection">
                                                <hr>
                                                <p class="head">{{'Workflow'|translate}}</p>
                                                <hr>
                                                <br>
                                                <table width="100%" cellspacing="0" class="lateststatus"
                                                    *ngIf="workFlowAvailable">
                                                    <tbody>
                                                        <tr>
                                                            <th align="left">{{'Time'|translate}}</th>
                                                            <th align="left">{{'State'|translate}}</th>
                                                        </tr>
                                                        <tr *ngFor="let i of workflowStateDetails">
                                                            <td> {{i.time.substring(0,10)}}&nbsp;{{i.time.substring(11,19)}}
                                                            </td>
                                                            <td>{{i.title}}</td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style="display: none" id="vehicleSection">
                                                <hr>


                                                <p class="head">{{'Vehicle Model'|translate}}</p>




                                                <hr>
                                                <div class="sessionTitle">{{'Vehicle'|translate}}</div>
                                                <table class="lateststatus">
                                                    <tbody>
                                                        <tr>
                                                            <td>vehicleType:</td>
                                                            <td>VEHICLE</td>
                                                        </tr>
                                                        <tr>
                                                            <td>vehicleLookupType:</td>
                                                            <td>
                                                                <table width="100%" class="lateststatus">
                                                                    <tbody>
                                                                        <tr>

                                                                            <td>{{'Type'|translate}}:</td>



                                                                            <td></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>isManualLookup:</td>
                                                                            <td>{{ vehicleVinData }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>vehicleManufacturer:</td>
                                                            <td>
                                                                <table width="100%" class="lateststatus">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>{{'Type'|translate}}:</td>
                                                                            <td></td>
                                                                        </tr>
                                                                        <tr>

                                                                            <td>{{'Name'|translate}}:</td>


                                                                            <td>Ford</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="sbdoService">
                                                            <td>displayName:</td>
                                                            <td>
                                                                <table width="100%" class="lateststatus">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>{{'ID'|translate}}:</td>
                                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                                hardFeaturesData.DisplayName[0].ID[0] }}
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>prefix:</td>
                                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                                hardFeaturesData.DisplayName[0].Prefix[0]
                                                                                }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>startDate:</td>
                                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                                hardFeaturesData.DisplayName[0].StartDate[0]
                                                                                }}</td>
                                                                        </tr>
                                                                        <tr>

                                                                            <td>{{'Name'|translate}}:</td>


                                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                                hardFeaturesData.DisplayName[0].Name[0]
                                                                                }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{'Build date'|translate}}:</td>
                                                            <td *ngIf="vehicleDetailsAvailable && sbdoService">{{
                                                                hardFeaturesData.BuildDate[0] }}</td>
                                                        </tr>
                                                        <tr *ngIf="!sbdoService">
                                                            <td>displayName:</td>
                                                            <td>displayName:</td>
                                                            <td>
                                                                <table width="100%" class="lateststatus">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>{{'ID'|translate}}:</td>
                                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                                vehicleDetails['vehicle:displayName'][0]['vehicle:id'][0]
                                                                                }}
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>prefix:</td>
                                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                                vehicleDetails['vehicle:displayName'][0]['vehicle:prefix'][0]
                                                                                }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>startDate:</td>
                                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                                vehicleDetails['vehicle:displayName'][0]['vehicle:startDate'][0]
                                                                                }}</td>
                                                                        </tr>
                                                                        <tr>

                                                                            <td>{{'Name'|translate}}:</td>


                                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                                vehicleDetails['vehicle:displayName'][0]['vehicle:name'][0]
                                                                                }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{'Build date'|translate}}:</td>
                                                            <td *ngIf="vehicleDetailsAvailable && !sbdoService">{{
                                                                hardFeaturesData['vehicle:buildDate'][0] }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{'VIN'|translate}}:</td>
                                                            <td>
                                                                <value-of select="."></value-of>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>readVin:</td>
                                                            <td>
                                                                <table width="100%" class="lateststatus">
                                                                    <tbody>
                                                                        <tr>

                                                                            <td>{{'VIN'|translate}}:</td>


                                                                            <td>{{ vinAvailable }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="vehicleDetailsAvailable && sbdoService">
                                                            <td>{{'features'|translate}}:</td>
                                                            <td>
                                                                <table width="100%" class="lateststatus">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>{{'VIN'|translate}}:</td>
                                                                            <td>{{ vinAvailable }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{{'Model year'|translate}}:</td>
                                                                            <td>{{ hardFeaturesData.ModelYear[0] }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{{'Build Date'|translate}}:</td>
                                                                            <td>{{ hardFeaturesData.BuildDate[0] }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{{'Primary Features'|translate}}:</td>
                                                                            <td>
                                                                            </td>
                                                                        </tr>
                                                                        <tr
                                                                            *ngFor="let p of hardFeaturesData.PrimaryFeatureCodes[0].PrimaryFeatureCode">
                                                                            <td>entry:</td>
                                                                            <td>
                                                                                <table width="100%"
                                                                                    class="lateststatus">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>key:</td>
                                                                                            <td>{{ p.Key }}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>value:</td>
                                                                                            <td>{{ p.Value }}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr
                                                                            *ngFor="let p of hardFeaturesData.MinorFeatureCodes[0].MinorFeatureCode">
                                                                            <td>minorFeatures:</td>
                                                                            <td>{{ p }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="vehicleDetailsAvailable && !sbdoService">
                                                            <td>{{'features'|translate}}:</td>
                                                            <td>
                                                                <table width="100%" class="lateststatus">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>{{'VIN'|translate}}:</td>
                                                                            <td>{{ vinAvailable }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{{'Model year'|translate}}:</td>
                                                                            <td>{{
                                                                                hardFeaturesData['vehicle:modelYear'][0]
                                                                                }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{{'Build Date'|translate}}:</td>
                                                                            <td>{{
                                                                                hardFeaturesData['vehicle:buildDate'][0]
                                                                                }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{{'Primary Features'|translate}}:</td>
                                                                            <td>
                                                                            </td>
                                                                        </tr>
                                                                        <tr
                                                                            *ngFor="let p of hardFeaturesData['vehicle:primaryFeatures'][0]['vehicle:entry']">
                                                                            <td>entry:</td>
                                                                            <td>
                                                                                <table width="100%"
                                                                                    class="lateststatus">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>key:</td>
                                                                                            <td>{{ p['vehicle:key'][0]
                                                                                                }}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>value:</td>
                                                                                            <td>{{ p['vehicle:value'][0]
                                                                                                }}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr
                                                                            *ngFor="let p of hardFeaturesData['vehicle:minorFeatures']">
                                                                            <td>minorFeatures:</td>
                                                                            <td>{{ p }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <!-- <tr>
                                                        <td>registrationList:</td>
                                                        <td>
                                                            <table width="100%" class="lateststatus">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>country:</td>
                                                                        <td>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>date:</td>
                                                                        <td>20101223</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>registration:</td>
                                                                        <td>LB08NMM</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>vin:</td>
                                                                        <td>
                                                                            WF0JXXWPBJAS38295
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr> -->
                                                        <tr *ngIf="vehicleDetailsAvailable">
                                                            <td>publicationKeys:</td>
                                                            <td>
                                                                <table width="100%" class="lateststatus">
                                                                    <tbody>
                                                                        <tr *ngFor="let i of publicationData">
                                                                            <td>deliverableKey:</td>
                                                                            <td>{{i}}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <!-- <div class="sessionTitle">evisData</div>
                                            <div class="sessionTitle">dtcs</div>
                                            <table class="lateststatus">
                                                <tbody>
                                                    <tr>
                                                        <th>nodeAddress</th>
                                                        <th>protocol</th>
                                                        <th>description</th>
                                                        <th>dtcId</th>
                                                        <th>dtcValue</th>
                                                        <th>dtcTransform</th>
                                                        <th>dtcFailureType</th>
                                                        <th>dtcStatusBit</th>
                                                    </tr>
                                                    <tr>
                                                        <td>726</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7e6</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7e3</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>733</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>734</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7e1</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7d5</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7c7</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>736</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>721</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>774</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>740</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>713</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>793</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7b2</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>732</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7d0</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>746</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>751</td>
                                                        <td>GDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>791</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>730</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>783</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>716</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>775</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7e0</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>701</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>741</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>714</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>754</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>727</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7a7</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7e4</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>7a5</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>No Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>797</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>731</td>
                                                        <td>GGDS</td>
                                                        <td></td>
                                                        <td>Negative Response</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table> -->
                                                <!-- <div class="sessionTitle">obds</div>
                                            <div class="sessionTitle">genericData</div>
                                            <table class="lateststatus">
                                                <tbody>
                                                    <tr>
                                                        <th>nodeAddress</th>
                                                        <th>mode</th>
                                                        <th>name</th>
                                                        <th>rawValue</th>
                                                        <th>decodedValue</th>
                                                        <th>transformFormat</th>
                                                    </tr>
                                                </tbody>
                                            </table> -->
                                                <div class="sessionTitle">warrantyDetail</div>
                                                <div class="sessionTitle">warrantyBasicInformation</div>
                                                <table *ngIf="sbdoService" style="margin-top: 5mm; margin-bottom: 5mm">
                                                    <tbody>
                                                        <tr>
                                                            <th align="left">saleMileage:&nbsp;</th>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">buildStartdate:&nbsp;</th>
                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                hardFeaturesData.BuildDate[0] | date:'dd/MM/yyyy' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">warrantyStartDate:&nbsp;</th>
                                                            <td>{{ warrantyDate | date:'dd/MM/yyyy' }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table *ngIf="!sbdoService" style="margin-top: 5mm; margin-bottom: 5mm">
                                                    <tbody>
                                                        <tr>
                                                            <th align="left">saleMileage:&nbsp;</th>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">buildStartdate:&nbsp;</th>
                                                            <td *ngIf="vehicleDetailsAvailable">{{
                                                                hardFeaturesData['vehicle:buildDate'][0] |
                                                                date:'dd/MM/yyyy' }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th align="left">warrantyStartDate:&nbsp;</th>
                                                            <td>{{ warrantyDate | date:'dd/MM/yyyy' }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <!-- <div class="sessionTitle">fsaEntry</div>
                                            <table class="lateststatus">
                                                <tbody>
                                                    <tr>
                                                        <th>key</th>
                                                        <th>value</th>
                                                    </tr>
                                                    <tr>
                                                        <td>18P11</td>
                                                        <td>MONDEO, GALAXY / SMAX - BATTERY MONITORING SENSOR</td>
                                                    </tr>
                                                    <tr>
                                                        <td>20B02</td>
                                                        <td>MONDEO / GALAXY SMAX - EPAS STEERING GEAR MOTOR BOLTS</td>
                                                    </tr>
                                                </tbody>
                                            </table> -->
                                                <div *ngIf='moduleDetailsAvailable && sbdoService'>
                                                    <div *ngFor="let module of moduleSoftwareDetails">
                                                        <div class="sessionTitle">currentDidList</div>
                                                        <table style="margin-top: 5mm; margin-bottom: 5mm">
                                                            <tbody>
                                                                <tr>
                                                                    <th align="left">specificationCat:
                                                                    </th>
                                                                    <td>{{ module.SpecificationCategory[0] }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">{{'Date'|translate}}:
                                                                    </th>
                                                                    <td *ngIf="sessionAvailable">{{
                                                                        sessionDetails.sessionOpen }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">{{'Name'|translate}}:
                                                                    </th>
                                                                    <td>{{ module.Name[0] }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">{{'Address'|translate}}:
                                                                    </th>
                                                                    <td>{{ module.Address[0] }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">networkTypes:
                                                                    </th>
                                                                    <td *ngIf="module.NetworkTypes[0]">
                                                                        {{module.NetworkTypes[0].NetworkType[0].NetworkType[0]}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">physicalNetworkName:
                                                                    </th>
                                                                    <td>{{ module.PhysicalNetworkName?
                                                                        module.PhysicalNetworkName[0] :
                                                                        module.PhysicalNetworkName }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">gatewayType:
                                                                    </th>
                                                                    <td>{{ module.GatewayType[0]}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">stateChangeDate:
                                                                    </th>
                                                                    <td>{{ module.StateChangeDate[0] }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <table class="lateststatus"
                                                            *ngFor='let m of module.DiagnosticIdentifierResponses'>
                                                            <tbody>
                                                                <tr>
                                                                    <th>identifier</th>
                                                                    <th>didType</th>
                                                                    <th>isConfig</th>
                                                                    <th>partNumber</th>
                                                                    <th>VehicleRead</th>
                                                                    <th>FordDerived</th>
                                                                </tr>
                                                                <tr *ngFor='let p of m.DiagnosticIdentifierResponse'>
                                                                    <td>{{p.Identifier}}</td>
                                                                    <td style="text-transform: uppercase;">{{p.Type}}
                                                                    </td>
                                                                    <td class="center">{{p.Config}}</td>
                                                                    <td *ngIf="p.ResponseMessage">
                                                                        {{p.ResponseMessage[0].Response}}</td>
                                                                    <td *ngIf="!p.ResponseMessage"></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>
                                                <div *ngIf='moduleDetailsAvailable && !sbdoService'>
                                                    <div *ngFor="let module of currentDidList">
                                                        <div class="sessionTitle">currentDidList</div>
                                                        <table style="margin-top: 5mm; margin-bottom: 5mm">
                                                            <tbody>
                                                                <tr>
                                                                    <th align="left">specificationCat:
                                                                    </th>
                                                                    <td>{{
                                                                        module['vehicle:node'][0]['vehicle:specificationCat'][0]
                                                                        }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">{{'Date'|translate}}:
                                                                    </th>
                                                                    <td>{{ module['vehicle:node'][0]['vehicle:date'][0]
                                                                        }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">{{'Name'|translate}}:
                                                                    </th>
                                                                    <td>{{ module['vehicle:node'][0]['vehicle:name'][0]
                                                                        }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">{{'Address'|translate}}:
                                                                    </th>
                                                                    <td>{{
                                                                        module['vehicle:node'][0]['vehicle:address'][0]
                                                                        }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">networkTypes:
                                                                    </th>
                                                                    <td>{{
                                                                        module['vehicle:node'][0]['vehicle:networkTypes'][0]}}
                                                                    </td>
                                                                </tr>
                                                                <!-- <tr>
                                                                    <th align="left">physicalNetworkName:
                                                                    </th>
                                                                    <td>{{ module.PhysicalNetworkName[0]}}</td>
                                                                </tr> -->
                                                                <tr>
                                                                    <th align="left">gatewayType:
                                                                    </th>
                                                                    <td>{{
                                                                        module['vehicle:node'][0]['vehicle:gatewayType'][0]}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th align="left">stateChangeDate:
                                                                    </th>
                                                                    <td>{{
                                                                        module['vehicle:node'][0]['vehicle:specificationCat'][0]
                                                                        }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <table class="lateststatus">
                                                            <tbody>
                                                                <tr>
                                                                    <th>identifier</th>
                                                                    <th>didType</th>
                                                                    <th>isConfig</th>
                                                                    <th>partNumber</th>
                                                                    <th>VehicleRead</th>
                                                                    <th>FordDerived</th>
                                                                </tr>
                                                                <tr
                                                                    *ngFor="let p of module['vehicle:didResponses'], let ind = index">
                                                                    <td>{{p['vehicle:did'][0]['vehicle:identifier'][0]}}
                                                                    </td>
                                                                    <td style="text-transform: uppercase;">
                                                                        {{p['vehicle:did'][0]['vehicle:didType'][0]}}
                                                                    </td>
                                                                    <td class="center">
                                                                        {{p['vehicle:did'][0]['vehicle:isConfig'][0]}}
                                                                    </td>
                                                                    <td *ngIf="p['vehicle:response']">
                                                                        <span
                                                                            *ngIf="p['vehicle:response'][0]['vehicle:partNumber']">
                                                                            {{p['vehicle:response'][0]['vehicle:partNumber'][0]}}</span>
                                                                    </td>
                                                                    <td *ngIf="!p['vehicle:response']"></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>
                                                <div *ngIf="!flashActionError && !sbdoService">
                                                    <div *ngFor="let f of flashAction">
                                                        <div>flashActionList</div>
                                                        <div>assemblies:</div>
                                                        <table class="lateststatus">

                                                            <tbody>
                                                                <tr
                                                                    *ngFor="let s of f['vehicle:assemblies'][0]['vehicle:software']">
                                                                    <td>software:</td>
                                                                    <td>
                                                                        <table class="lateststatus">

                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>id</td>
                                                                                    <td>{{s['vehicle:id'][0]}}</td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>type</td>
                                                                                    <td>{{s['vehicle:type'][0]}}</td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>didValue</td>
                                                                                    <td>{{s['vehicle:didValue'][0]}}
                                                                                    </td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>current</td>
                                                                                    <td>{{s['vehicle:current'][0]}}</td>
                                                                                </tr>


                                                                                <tr
                                                                                    *ngIf="s['vehicle:supportingSoftware']">
                                                                                    <td>supportingSoftware:</td>
                                                                                    <td>
                                                                                        <table class="lateststatus">

                                                                                            <tbody
                                                                                                *ngFor="let ss of s['vehicle:supportingSoftware']">
                                                                                                <tr>
                                                                                                    <td>id</td>
                                                                                                    <td>{{ss['vehicle:id'][0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>type</td>
                                                                                                    <td>{{ss['vehicle:type'][0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>didValue</td>
                                                                                                    <td>{{ss['vehicle:didValue'][0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>current</td>
                                                                                                    <td>{{ss['vehicle:current'][0]}}
                                                                                                    </td>
                                                                                                </tr>


                                                                                                <tr>
                                                                                                    <td>uninstallable
                                                                                                    </td>
                                                                                                    <td>{{ss['vehicle:uninstallable'][0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>nodeAddress</td>
                                                                                                    <td>{{ss['vehicle:nodeAddress'][0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>

                                                                                <tr *ngIf="s['vehicle:softwareSize']">
                                                                                    <td>softwareSize</td>
                                                                                    <td>{{s['vehicle:softwareSize'][0]}}
                                                                                    </td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>uninstallable</td>
                                                                                    <td>{{s['vehicle:uninstallable'][0]}}
                                                                                    </td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>nodeAddress</td>
                                                                                    <td>{{s['vehicle:nodeAddress'][0]}}
                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>assemblyType:</td>
                                                                    <td>{{f['vehicle:assemblies'][0]['vehicle:assemblyType'][0]}}
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>nodeAddress:</td>
                                                                    <td>{{f['vehicle:assemblies'][0]['vehicle:nodeAddress'][0]}}
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>currentAssembly:</td>
                                                                    <td>{{f['vehicle:assemblies'][0]['vehicle:currentAssembly'][0]}}
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>availableAssembly:</td>
                                                                    <td>{{f['vehicle:assemblies'][0]['vehicle:availableAssembly'][0]}}
                                                                    </td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div *ngIf="!flashActionError && sbdoService">
                                                    <div *ngFor="let f of flashAction">
                                                        <div>flashActionList</div>
                                                        <div>assemblies:</div>
                                                        <table class="lateststatus">

                                                            <tbody>
                                                                <tr
                                                                    *ngFor="let s of f.Assemblies[0].Assembly[0].AssemblySoftware[0].AssemblySoftware">
                                                                    <td>software:</td>
                                                                    <td>
                                                                        <table class="lateststatus">

                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>id</td>
                                                                                    <td>{{s.ID[0]}}</td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>type</td>
                                                                                    <td>{{s.SoftwareType[0]}}</td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>didValue</td>
                                                                                    <td>{{s.DidValue[0]}}</td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>current</td>
                                                                                    <td>{{s.current[0]}}</td>
                                                                                </tr>


                                                                                <tr
                                                                                    *ngIf="s.SupportingSoftware[0].AssemblySoftware">
                                                                                    <td>supportingSoftware:</td>
                                                                                    <td>
                                                                                        <table class="lateststatus">

                                                                                            <tbody
                                                                                                *ngFor="let ss of s.SupportingSoftware[0].AssemblySoftware">
                                                                                                <tr>
                                                                                                    <td>id</td>
                                                                                                    <td>{{ss.ID[0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>type</td>
                                                                                                    <td>{{ss.SoftwareType[0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>didValue</td>
                                                                                                    <td>{{ss.DidValue[0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>current</td>
                                                                                                    <td>{{ss.current[0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>uninstallable
                                                                                                    </td>
                                                                                                    <td>{{ss.uninstallable[0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <td>nodeAddress</td>
                                                                                                    <td>{{ss.NodeAddress[0]}}
                                                                                                    </td>
                                                                                                </tr>

                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>

                                                                                <tr *ngIf="s.SoftwareSize">
                                                                                    <td>softwareSize</td>
                                                                                    <td>{{s.SoftwareSize[0]}}</td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>uninstallable</td>
                                                                                    <td>{{s.uninstallable[0]}}</td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>nodeAddress</td>
                                                                                    <td>{{s.NodeAddress[0]}}</td>
                                                                                </tr>

                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>assemblyType:</td>
                                                                    <td>{{f.Assemblies[0].Assembly[0].AssemblyType[0]}}
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>nodeAddress:</td>
                                                                    <td>{{f.Assemblies[0].Assembly[0].NodeAddress[0]}}
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>currentAssembly:</td>
                                                                    <td>{{f.Assemblies[0].Assembly[0].CurrentAssembly[0]}}
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>availableAssembly:</td>
                                                                    <td>{{f.Assemblies[0].Assembly[0].AvailableAssembly[0]}}
                                                                    </td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="otxDataAvailable" style="display: none" id="otxSection">
                                                <hr>
                                                <p class="head">OTX</p>
                                                <hr>
                                                <table *ngIf="!otxDataError" width="100%" class="lateststatus"
                                                    cellspacing="0" cellpadding="1" border="1">
                                                    <tbody>
                                                        <tr>
                                                            <th align="center">Title</th>
                                                            <th align="center">Start</th>
                                                            <th align="center">Question</th>
                                                            <th align="center">Outcome/Parameter</th>
                                                            <th align="center">Data</th>
                                                        </tr>
                                                        <tr *ngFor="let i of otxData">
                                                            <td valign="top">{{i['otx:screenName'][0]}}</td>
                                                            <td valign="top" align="center">{{i['otx:time'][0]}}</td>
                                                            <td valign="top">{{i['otx:screenLocation'][0]}}</td>
                                                            <td valign="top">{{i['otx:outcome'][0].$.returnType}}</td>
                                                            <td valign="top"></td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div *ngIf="noOtxData">
                                                    No Data Available
                                                </div>
                                            </div>
                                            <!-- <div style="display: none" id="ctSection">
                                            <hr>
                                            <h6>Complex Tools</h6>
                                            <hr>
                                        </div> -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>

        {{todayDate | date:'long':'BST'}}
    </div>

    <div style="display: block" id="loader" class="loader2">
        <img id="loadSpinnerImg1" src="assets/images/ajax-loader.gif" width="100" height="100">
    </div>

    <!-- October 6, 2021 8:01:12 AM BST -->
</body>
<ng-template #gtacRap let-modal>
    <div class="container NWTContainer">
        <div class="row popup-header">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="modal.dismiss('NWTErrorInfo')"></i></div>
        </div>
        <div>
            <label class='msg-body'>
                <p>{{'RAPMsg'|translate}}?<br>
                    {{'RAPMsg1'|translate}}.<br>
                    {{'RAPMsg2'|translate}}.<br>
                    {{'RAPMsg3'|translate}}?</p>
            </label>
        </div>
        <hr class="hr-line">
        <div class="popup-footer">
            <button type="button" class="close-btn-popup pull-right" name="GTAC"
                (click)="modal.dismiss('gtacRap');contactSubmit(content)">GTAC</button>
            <button type="button" class="close-btn-popup pull-right" name="RAP"
                (click)="modal.dismiss('gtacRap');reportAProblemPopup()">RAP</button>
        </div>
    </div>
</ng-template>
<div class="contain-popup">
    <ng-template #content let-modal>
        <div class="forborder">
            <div class="modal-header">
                <i class="fa fa-times mng-qualifier-close-btn" style="margin-left: 450px;"
                    (click)="modal.dismiss('Cross click')" title="close">
                </i>
            </div>
            <div class="modal-body">
                <div class="newBorder">
                    {{'pleasecontact'|translate}}: wdmoeuhl@msxi.com
                </div>
            </div>
        </div>
    </ng-template>
</div>
